import { api } from "./http";

/** Lista de notificaciones del usuario y cantidad de no leídas */
export async function getNotifications() {
	const res = await api.get("/api/notifications/");
	return res.data;
}

/** Marcar una notificación como leída */
export async function markNotificationRead(id) {
	await api.patch("/api/notifications/", { id });
}

/** Marcar todas como leídas */
export async function markAllNotificationsRead() {
	await api.patch("/api/notifications/", { mark_all_read: true });
}
